import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEditBulk';
import { FORM_FIELD_CONFIG_EDIT, FORM_LAYOUT_CONFIG_EDIT, validationSchemaEdit } from '../../utils/bulkFormConfig';

const EditBulkCoupon: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			validationSchema={validationSchemaEdit}
			fieldConfig={FORM_FIELD_CONFIG_EDIT}
			layoutConfig={FORM_LAYOUT_CONFIG_EDIT}
		/>
	);
};

export default EditBulkCoupon;
